var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.msgToAppear)?_c('div',{staticClass:"voucher-message",class:{'red-colored': !_vm.isActive},style:({'height': _vm.heightBasedOnMsgLength(_vm.msgToAppear)})},[_vm._v("\n\t\t"+_vm._s(_vm.msgToAppear)+"\n\t")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }